/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { addModal } from 'config/modals/registry';
import { wrapImport } from 'decorators/ModuleLoader';

const VoidInvoiceModal = wrapImport(() => import(/* webpackChunkName: "modals" */ './index'));

export default addModal('VoidInvoiceModal', VoidInvoiceModal, { wide: true });
